var render = function render(){var _vm=this,_c=_vm._self._c;return (
		typeof _vm.currentLiveInventoryId !== 'undefined' &&
		_vm.currentLiveInventoryId !== null &&
		_vm.currentLiveInventoryId.toString().length > 0 &&
		!_vm.liveMode
	)?_c('div',[_c('a',{staticClass:"bannerLink backgroundColorDefault bannerContainer",attrs:{"href":'/items/' +
			_vm.currentLiveInventoryId +
			'/' +
			'?advanceWithPodium=true&inventoryId=' +
			_vm.currentLiveInventoryId}},[_vm._v("\n\t\tClick here to join the Live Auction\n\t")])]):(_vm.liveMode)?_c('div',[_c('a',{staticClass:"backgroundColorLightGrey bannerContainer",attrs:{"href":_vm.exitUrl}},[_vm._v("Click here to leave the Live Auction")])]):(_vm.banner !== false)?_c('div',[_c('a',{staticClass:"bannerLink backgroundColorDefault bannerContainer",attrs:{"href":_vm.banner.link || '/'}},[_vm._v("\n\t\t"+_vm._s(_vm.banner.copy)+"\n\t")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }